import * as React from 'react';

import { DataRequestActionTypes } from '../../constants/actionTypes';
import { FormId } from '../../constants/formId';
import FormModal from '../modal/formModal';

import BaseUserForm from './baseUserForm';

// eslint-disable-next-line react/prefer-stateless-function
export class EditUserForm extends React.Component<{}> {
  public render() {
    return (
      <FormModal
        formId={FormId.EditUserForm}
        formTitle="Edit"
        submitActionType={DataRequestActionTypes.EditUserRequested}
        hideButton
        partialSubmit
      >
        <BaseUserForm formId={FormId.EditUserForm} />
      </FormModal>
    );
  }
}
